/**
 * Centralised semantic colour maps shared across pages (Library, Discovery,
 * People/Author, Graph). Keeps inline colour logic from drifting per-page.
 */
import { accentSurface } from '../../theme/mvkgTokens';

// Article / task pipeline status → accent key + display label + pulse flag.
export const STATUS_VISUAL = {
  completed:      { accent: 'emerald', label: 'Ready',          pulse: false },
  extracting:     { accent: 'brand',   label: 'Extracting',     pulse: true  },
  processing:     { accent: 'brand',   label: 'Processing',     pulse: true  },
  canonicalizing: { accent: 'purple',  label: 'Canonicalizing', pulse: true  },
  loading:        { accent: 'sky',     label: 'Loading',        pulse: true  },
  queued:         { accent: 'amber',   label: 'Queued',         pulse: false },
  pending:        { accent: 'gray',    label: 'Pending',        pulse: false },
  failed:         { accent: 'rose',    label: 'Failed',         pulse: false },
  cancelled:      { accent: 'gray',    label: 'Cancelled',      pulse: false },
  duplicate:      { accent: 'amber',   label: 'Duplicate',      pulse: false },
  approved:       { accent: 'emerald', label: 'Approved',       pulse: false },
  rejected:       { accent: 'rose',    label: 'Rejected',       pulse: false },
};

// Research-direction / method lifecycle phase palette.
export const PHASE_PALETTE = {
  disruption:    { accent: 'rose',   label: 'Disruption' },
  emerging:      { accent: 'amber',  label: 'Emerging' },
  consolidation: { accent: 'blue',   label: 'Consolidation' },
  mature:        { accent: 'gray',   label: 'Mature' },
};

// Author lineage role pills (Digest lineage, Author profile).
export const ROLE_PILL = {
  foundational: { accent: 'purple', label: 'Foundational' },
  comparison:   { accent: 'amber',  label: 'Comparison' },
  reference:    { accent: 'gray',   label: 'Reference' },
  extension:    { accent: 'emerald', label: 'Extension' },
  product:      { accent: 'blue',   label: 'Product variant' },
  ideator:      { accent: 'brand',  label: 'Ideator' },
  consolidator: { accent: 'cyan',   label: 'Consolidator' },
  connector:    { accent: 'pink',   label: 'Connector' },
  specialist:   { accent: 'amber',  label: 'Specialist' },
};

/** Map a CD5 / disruption score to a phase-style accent band. */
export function cd5Band(value) {
  const v = Number(value);
  if (!Number.isFinite(v)) return { accent: 'gray', label: '—' };
  if (v > 0.3)  return { accent: 'rose',   label: 'Breakthrough' };
  if (v > 0.1)  return { accent: 'amber',  label: 'Innovative' };
  if (v >= -0.1) return { accent: 'gray',  label: 'Mixed' };
  return { accent: 'blue', label: 'Consolidating' };
}

export const surfaceFor = (accentKey) => accentSurface[accentKey] || accentSurface.gray;
